import { Alert, Box, Button, Fab, Typography } from '@mui/material';
import React, { Component } from 'react';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from 'axios';
import FollowUp123 from '.';
import { Campaign, ClearAll } from '@mui/icons-material';

class NotifyFuSalesOnline extends Component {
    state = {
        anchorEl: null,
        isMenuOpen: false,
        appNumber: Global.getAppProfile().waNumber,
        showList: false
    }

    getContactInfo = (waNumber) => {
        const params = { waNumber: waNumber };
        axios
            .post(Api.getContactInfo(), params, Api.getRequestHeader())
            .then((response) => {
                const responseData = response.data;
                if (responseData.success === true) {
                    const contact = this.props.generateItemConversation(responseData.data);
                    this.props.handleConversationSelected(contact);
                }
            })
            .catch((error) => {
                this.setState({ errorMessage: error.message });
                console.error("There was an error!", error);
            });
    }

    toggleShowList = () => {
        this.setState({ showList: !this.state.showList });
    }

    render() {
        const hasFu = this.props.countListFuSalesOnline > 0;

        if (this.props.mode === "fab") {
            return (
                <Box sx={{ m: "5px" }}>
                    <Fab
                        variant="extended"
                        size="small"
                        sx={{ position: "fixed", bottom: 20, left: "20vw", textTransform: "none", fontWeight: 600 }}
                        color="error"
                        onClick={this.toggleShowList}
                    >
                        <Campaign sx={{ mr: 1 }} /> Follow Up
                    </Fab>
                    {this.state.showList && <FollowUp123 onClose={this.toggleShowList} {...this.props} />}
                </Box>
            );
        }

        return (
            <Box sx={{ m: "8px" }}>
                <Alert
                    severity={hasFu ? "error" : "info"}
                    variant="standard"
                    icon={<Campaign />}
                    action={
                        <Button
                            size="small"
                            variant="contained"
                            color={hasFu ? "error" : "primary"}
                            disableElevation
                            startIcon={<ClearAll />}
                            onClick={this.toggleShowList}
                            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, whiteSpace: "nowrap", alignSelf: "center" }}
                        >
                            Lihat Customer FU
                        </Button>
                    }
                    sx={{
                        borderRadius: "12px",
                        alignItems: "center",
                        border: hasFu ? "1px solid #f5c2c0" : "1px solid #b6d4fa",
                        "& .MuiAlert-message": { py: "4px" },
                    }}
                >
                    <Typography sx={{ fontSize: 13.5 }}>
                        {hasFu
                            ? "Ada data yang harus segera di-follow up. Cek sekarang!"
                            : "Lihat customer yang perlu di Follow Up."}
                    </Typography>
                </Alert>

                {this.state.showList && <FollowUp123 onClose={this.toggleShowList} {...this.props} />}
            </Box>
        );
    }
}

export default NotifyFuSalesOnline;
